import { identityApiInstance } from "../apiInstance";

export const getCurrentUserPermissions = async (): Promise<string[]> => {

    const { data: permissions } = await identityApiInstance.get<string[]>('permissions');
    
    return permissions;
}